import React from 'react'

import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { cx } from 'tss-react/@emotion/css'

import { SubspaceListViewFilters } from '../../scenes/SubspaceListView/SubspaceListViewStore'
import { DebouncedTextFilter } from '../../../../components/DebouncedTextFilter'

export type SubspaceFiltersProps = {
  className?: string
  filters: SubspaceListViewFilters
  onChange: (filters: SubspaceListViewFilters) => void
}

export function SubspaceFilters({ className, filters, onChange }: SubspaceFiltersProps) {
  const { classes } = useStyles()

  const handleIdChange = (id: string) => {
    onChange({ ...filters, id: Number(id) })
  }
  const handleUserIdChange = (userId: string) => {
    onChange({ ...filters, userId: Number(userId) })
  }
  const handleSpaceIdChange = (spaceId: string) => {
    onChange({ ...filters, spaceId: Number(spaceId) })
  }
  const handleNameChange = (name: string) => {
    onChange({ ...filters, name })
  }

  return (
    <div className={cx(className, classes.filterList)}>
      <DebouncedTextFilter defaultValue={filters.id?.toString()} placeholder="Id..." onChange={handleIdChange} />
      <DebouncedTextFilter
        defaultValue={filters.userId?.toString()}
        placeholder="User Id..."
        onChange={handleUserIdChange}
      />
      <DebouncedTextFilter
        defaultValue={filters.spaceId?.toString()}
        placeholder="Space Id..."
        onChange={handleSpaceIdChange}
      />
      <DebouncedTextFilter defaultValue={filters.name} placeholder="Name..." onChange={handleNameChange} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  filterList: {
    display: 'flex',
    gap: spacing(2),
  },
}))
